"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/Editor.css");
require("react-quill/dist/quill.snow.css");
var _reactQuill = _interopRequireDefault(require("react-quill"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : Editor.js
* Description : Ce fichier contient la définition du composant Editor 
*               Ce composant fournie un éditeur de texte avec une toolbar pour formatter le texte
* Date de création : 1 décembre 2025
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */

/**
* Editor : Ce composant fournie un éditeur de texte avec une toolbar pour formatter le texte 
*
* Type : composant 
*
* Parametres : 
*  - value -- valeur du texte enrichi
*  - setValue -- fonction pour mettre à jour le texte enrichi
*/function Editor(_ref) {
  var value = _ref.value,
    setValue = _ref.setValue;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactQuill["default"], {
    theme: "snow",
    value: value,
    onChange: setValue,
    modules: {
      toolbar: [[{
        'header': [1, 2, 3, false]
      }], ['bold', 'italic', 'underline', 'strike'], [{
        'color': []
      }, {
        'background': []
      }], [{
        'align': []
      }], [{
        'list': 'ordered'
      }, {
        'list': 'bullet'
      }], ['clean']]
    }
  });
}
var _default = exports["default"] = Editor;